const state = {
  actable_id: '',
  actable_type: '',
  agency_id: '',
  agent_title: '',
  assigned_agent_ids: [],
  association_id: '',
  association_type: '',
  business_name: '',
  business_number: '',
  commission_fee: '',
  commission_structure: '',
  country_calling_code: '+61',
  cover_letter: '',
  custom_permissions: {},
  customizable_permissions: {},
  ebu_admin: false,
  email: '',
  enable_custom_permissions: false,
  first_name: '',
  id: null,
  last_name: '',
  license_number: '',
  mobile_number: '',
  options: {},
  password: '',
  password_confirmation: '',
  profile: '',
  profile_video_id: '',
  profile_video_provider: '',
  role_id: '',
  time_zone: '',
  username: '',
}

export const requiredFields = [
  { key: 'first_name' },
  { key: 'last_name' },
  { key: 'username' },
]

export default state
